import {
  useGetCurrentPasswordStrength,
  useGetCurrentPasswordStrengthColor,
} from "../../../../hooks/auth";
import { useResetPasswordContext } from "./ResetPasswordProvider";
import {
  RegisterPasswordStrengthActions,
  useRegisterPasswordStrengthContext,
} from "../register/RegisterPasswordStrength/RegisterPasswordStrengthProvider";
import React, { useEffect } from "react";

type ResetPasswordWrapperProps = React.ComponentProps<"div">;

export const ResetPasswordStrengthWrapper = ({
  children,
}: ResetPasswordWrapperProps) => {
  const { state } = useResetPasswordContext();
  const { dispatch } = useRegisterPasswordStrengthContext();
  const passwordStrength = useGetCurrentPasswordStrength({
    password: state.password,
  });

  useGetCurrentPasswordStrengthColor();

  useEffect(() => {
    dispatch({
      type: RegisterPasswordStrengthActions.SET_PASSWORD_STRENGTH,
      payload: passwordStrength,
    });
  }, [passwordStrength]);

  return <div className={"flex items-center gap-4 "}>{children}</div>;
};
